// extracted by mini-css-extract-plugin
module.exports = {"kumkumadiLowerBanner":"KumkumadiLowerBanner_kumkumadiLowerBanner__eTc3N","kumkumadiLowerBannerParent":"KumkumadiLowerBanner_kumkumadiLowerBannerParent__ATgjy"};